import axios from "axios";
import { FundamentalsFlow } from "@/models/fundamentals-flow";

// Income-statement flow (Sankey) data per fiscal period.
// Served by the DRF endpoint /interface/api/fundamentals/stock/<id>/flow/.
export const getFundamentalsFlow = async (stockId: number, period: string): Promise<FundamentalsFlow> => {
    const res = await axios.get<FundamentalsFlow>(`/interface/api/fundamentals/stock/${stockId}/flow/`, { params: { period } });
    return res.data;
};
